export default __webpack_public_path__ + "static/Quickinstallation_10-949a34506289e4b78dd2e38fe01d8535.webp";